import {Card} from 'react-bootstrap';
import {Link} from 'react-router-dom';


const checkCompany = (company) => {
  switch(company){
    case "Catholic Charities":
      return 'cc-color';
    case "Cemeteries":
      return 'cem-color';
    case "Diocese of Camden":
      return 'doc-color';
    case "Housing":
      return 'house-color';
    default:
  }
}


const Site = ({site}) => {
  return (
    <Link to={`/sites/${site._id}`}>
      <Card className={`my-3 p-3 rounded site-card ${checkCompany(site.company)}`}>
          <Card.Body>
              <Card.Title as="div">
                  <div className='card-Header'>{site.name}</div>
                  <div className='sm-text'>{site.abbr}</div>
              </Card.Title>
              <Card.Text>
              </Card.Text>
          </Card.Body>
          <Card.Footer className="siteCard-footertxt">{site.company}</Card.Footer>
      </Card>
    </Link>
  )
}

export default Site